import { combineReducers, configureStore } from '@reduxjs/toolkit'
import productReducer from './reducers/productReducer'
import userReducer from './reducers/userReducer'

const rootReducer = combineReducers({
  productReducer,
  userReducer,
})

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
